var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.hideHeader)?_c('header-nav',{attrs:{"is-bule":_vm.$route.meta.isBule}}):_vm._e(),_c('router-view'),(!_vm.$route.meta.hideFooter)?_c('footer-nav'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }